var map = {
	"./10-Clubs.svg": 2321,
	"./10-Diamond.svg": 2322,
	"./10-Hearts.svg": 2323,
	"./10-Spades.svg": 2324,
	"./2-Clubs.svg": 2325,
	"./2-Diamond.svg": 2326,
	"./2-Hearts.svg": 2327,
	"./2-Spades.svg": 2328,
	"./3-Clubs.svg": 2329,
	"./3-Diamond.svg": 2330,
	"./3-Hearts.svg": 2331,
	"./3-Spades.svg": 2332,
	"./4-Clubs.svg": 2333,
	"./4-Diamond.svg": 2334,
	"./4-Hearts.svg": 2335,
	"./4-Spades.svg": 2336,
	"./5-Clubs.svg": 2337,
	"./5-Diamond.svg": 2338,
	"./5-Hearts.svg": 2339,
	"./5-Spades.svg": 2340,
	"./6-Clubs.svg": 2341,
	"./6-Diamond.svg": 2342,
	"./6-Hearts.svg": 2343,
	"./6-Spades.svg": 2344,
	"./7-Clubs.svg": 2345,
	"./7-Diamond.svg": 2346,
	"./7-Hearts.svg": 2347,
	"./7-Spades.svg": 2348,
	"./8-Clubs.svg": 2349,
	"./8-Diamond.svg": 2350,
	"./8-Hearts.svg": 2351,
	"./8-Spades.svg": 2352,
	"./9-Clubs.svg": 2353,
	"./9-Diamond.svg": 2354,
	"./9-Hearts.svg": 2355,
	"./9-Spades.svg": 2356,
	"./A-Clubs.svg": 2357,
	"./A-Diamond.svg": 2358,
	"./A-Hearts.svg": 2359,
	"./A-Spades.svg": 2360,
	"./J-Clubs.svg": 2361,
	"./J-Diamond.svg": 2362,
	"./J-Hearts.svg": 2363,
	"./J-Spades.svg": 2364,
	"./K-Clubs.svg": 2365,
	"./K-Diamond.svg": 2366,
	"./K-Hearts.svg": 2367,
	"./K-Spades.svg": 2368,
	"./Q-Clubs.svg": 2369,
	"./Q-Diamond.svg": 2370,
	"./Q-Hearts.svg": 2371,
	"./Q-Spades.svg": 2372,
	"./temp card.svg": 2373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2320;